import { useState } from 'react'
import dynamic from 'next/dynamic'
import { IconLessonsDefault, Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { TRACK_CONTENT_TYPES } from '@mc/track-event'
import CTA from 'components/CTA'
import { ACTIONS, TrackProps, trackAction } from '../events'

const VideoModal = dynamic(() => import('components/VideoModal'), {
  ssr: false,
})

export interface SampleProps {
  brightcoveVideoId?: string | null
  mediaUuid?: string | null
  instructorName?: string | null
  headline?: string | null
  instructorAvatar?: string | null
  id?: string | number | null
  title?: string | null
  slug?: string | null
}

const SampleAction = ({
  trackProps,
  sample,
}: {
  trackProps: TrackProps
  sample?: SampleProps
}) => {
  const [isOpen, setIsModalOpen] = useState(false)
  const { t } = useTranslation('@mc/next')

  if (!sample?.brightcoveVideoId && !sample?.mediaUuid) return <></>

  const handleClick = () => {
    trackAction(trackProps, ACTIONS.SAMPLE)
    setIsModalOpen(true)
  }

  return (
    <>
      <Button
        kind='link'
        className='d-inline-flex flex-column'
        onClick={handleClick}
      >
        <IconLessonsDefault className='mc-icon--4 mc-mb-4' size='lg' />
        {t('course.sample')}
      </Button>

      {isOpen && (
        <VideoModal
          show={isOpen}
          isSample
          onCloseModal={() => setIsModalOpen(false)}
          videoId={sample.brightcoveVideoId}
          mediaUuid={sample.mediaUuid ?? ''}
          author={sample.instructorName ?? undefined}
          tagline={sample.headline ?? undefined}
          instructorAvatar={sample.instructorAvatar ?? undefined}
          contentId={`${sample.id}_${
            sample.brightcoveVideoId ?? sample.mediaUuid
          }`}
          contentTitle={sample.title ?? ''}
          contentType={TRACK_CONTENT_TYPES.COURSE_SAMPLE}
          courseId={sample.id || 0}
          buttonGroup={
            <CTA
              trackProps={{
                category: 'need-to-know',
                class: sample.slug,
                content_type: 'product',
                location: 'hero_sample_modal',
                page_category: 'personalization',
              }}
            />
          }
        />
      )}
    </>
  )
}

export default SampleAction
